import { PersonalReminderService } from '../../services/personal_reminder_service';
import { TypeUtility } from 'utility-ts-type';
import * as _4 from 'lodash4';
export class ExpandingReminderTextboxController {
  private readonly maxTitleLength: number;
  private reminderService: PersonalReminderService;

  constructor(private personalReminderService: PersonalReminderService, private ngTypeUtility: typeof TypeUtility) {
    this.maxTitleLength = 60;
    this.reminderService = personalReminderService;
  }

  approachingLengthLimit(titleText: string): boolean {
    return _4.isEmpty(titleText) ? false : this.maxTitleLength - titleText.length <= 10;
  }

  textSanitizerAndValidator(currentTitleText: string): void {
    this.personalReminderService.textSanitizerAndValidator(currentTitleText, this.maxTitleLength);
  }
}
angular
  .module('data-ng-personal-reminders')
  .controller('ExpandingReminderTextboxController', ExpandingReminderTextboxController);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/components/expanding_reminder_textbox/expanding_reminder_textbox_controller.ts